import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout';
import { Home, Calculator, ShowBy, NotFound, Login, AuthCallback } from './pages';
import { ProtectedRoute } from './components/auth';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/calculator"
          element={
            <ProtectedRoute>
              <Calculator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/show-by"
          element={
            <ProtectedRoute>
              <ShowBy />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

export default App;
